import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'appshell-link-joblog-admin-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './link-joblog-admin-shell.component.html',
  styleUrl: './link-joblog-admin-shell.component.scss',
})
export class LinkJoblogAdminShellComponent {}
